export default __webpack_public_path__ + "static/media/Essex_Icons_Money Bag.124339b1.svg";